import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const CurrentStockChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/inventoryJson`);
        

        if (response.data && response.data.data) {
          const rawData = response.data.data.Data;
          

          if (Array.isArray(rawData)) {
            const labels = rawData.map(item => item["Product Description"]);
            const data = rawData.map(item => item["Current Stock"]);

            const colorPalette = [
              "rgba(255, 99, 132, 0.6)",
              "rgba(54, 162, 235, 0.6)",
              "rgba(255, 206, 86, 0.6)",
              "rgba(75, 192, 192, 0.6)",
              "rgba(153, 102, 255, 0.6)",
              "rgba(255, 159, 64, 0.6)",
            ];

            const borderColorPalette = [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ];

            const dataset = {
              label: "Current Stock by Product",
              data: data,
              backgroundColor: colorPalette,
              borderColor: borderColorPalette,
              borderWidth: 1,
            };

            setChartData({
              labels: labels,
              datasets: [dataset],
            });
          } else {
            throw new Error("Data is not in expected array format.");
          }
        } else {
          throw new Error("Response does not contain expected Data property.");
        }
      } catch (error) {
        console.error("Error fetching or processing data:", error);
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "black",
            font: {
              size: 14,
            },
          },
        },
      },
      scales: {
        x: {
          beginAtZero: true,
        },
        y: {
          beginAtZero: true,
        },
      },
      interaction: {
        mode: "nearest",
        intersect: false,
        axis: "x",
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Current Stock Levels by Product
          </Typography>
        </Box>
        <Container>
          <div style={{ padding: "20px", width: "100%", height: "80%" }}>
            <Bar data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default CurrentStockChart;
